import classnames from 'classnames';

interface Props {
  description: string;
  className?: string;
}

const Description = ({ description, className }: Props) => {
  return (
    <span
      className={classnames(className)}
      style={{
        color: 'var(--description-text-color)',
      }}
    >
      {description}
    </span>
  );
};

export default Description;
